import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    InjectionToken,
    Injector,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { IAccessRightFilterCollection, ILightWeightObject } from '@fi-shared/models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiDropdownItemDisabledFn } from '@fi-shared/fi-select-search/fi-select-search';
import { isDefined } from '@fi-shared/utils';

export type TDataFieldEditBusinessAreasComponent_Settings = {
    lightWeightBusinessAreas$: Subject<ILightWeightObject[]>;
    accessRightFilterCollection: IAccessRightFilterCollection;
    dataFieldItemProperty: string;
    isNewSelectIcon?: boolean;
    isDisabledFunc?: (item: ILightWeightObject) => boolean;
};

export const DataFieldEditBusinessAreasComponent_Settings =
    new InjectionToken<TDataFieldEditBusinessAreasComponent_Settings>('DataFieldEditBusinessAreasComponent_Settings');

@Component({
    selector: 'data-field-edit-business-areas',
    templateUrl: './business-areas.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'data-field-edit-business-areas' },
    standalone: false,
})
export class DataFieldEditBusinessAreasComponent extends DataFieldEditBase implements OnInit {
    constructor(
        injector: Injector,
        @Inject(DataFieldEditBusinessAreasComponent_Settings)
        public settings: TDataFieldEditBusinessAreasComponent_Settings,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.subscribeOnBusinessAreasChange();
    }

    private subscribeOnBusinessAreasChange() {
        this.settings.lightWeightBusinessAreas$
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((businessAreas: ILightWeightObject[]) => {
                // autoselect business area if there is only one
                if (businessAreas.length === 1 && !this.dataFieldObject[this.settings.dataFieldItemProperty].length) {
                    this.dataFieldObject[this.settings.dataFieldItemProperty] = [businessAreas[0].Id];
                }
            });
    }

    isBusinessAreaDisabledFn: FiDropdownItemDisabledFn<ILightWeightObject> = (
        item: ILightWeightObject,
        allItems: ILightWeightObject[],
    ) => {
        if (isDefined(this.settings.isDisabledFunc)) {
            return this.settings.isDisabledFunc(item);
        }
        const availableBusinessAreaIds = allItems.map((item: ILightWeightObject) => item.Id);
        return availableBusinessAreaIds.indexOf(item.Id) === -1;
    };

    isNewSelectIcon(): boolean {
        return this.settings?.isNewSelectIcon;
    }
}
